module.exports = __webpack_public_path__ + "static/media/Imagineear_logo.5acdbbda.png";